import * as React from "react";
import {
	createFileRoute,
	useNavigate,
	useSearch,
	// useSearch
} from "@tanstack/react-router";
import {
	Card,
	CardHeader,
	CardTitle,
	CardDescription,
	CardContent,
} from "@/components/ui/card";
import {
	Yourself,
	Board,
	Workplace,
	Government,
} from "@/components/tables/TableBoardOfDirectors";
import { master } from "@/services/board-of-directors";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useParams } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_layout-private/report/board-of-directors/details/",
)({
	component: RouteComponent,
	validateSearch: (search: Record<string, unknown>) => {
		return {
			active: search.active as Tab,
		};
	},
});

type Tab = "yourself" | "board" | "workplace" | "Government";

function RouteComponent() {
	const navigate = useNavigate();
	const { active } = Route.useSearch();

	console.log("Active", active);

	// Define the tab change handler to update the query parameter
	const handleTabChange = (value: Tab) => {
		// setSearch({ tab: value });

		console.log(value, "Tab");

		navigate({
			to: "/report/board-of-directors/details",
			search: {
				active: value,
			},
		});
	};
	const { data: masterData, isLoading: isMasterLoading } = useQuery({
		queryKey: ["board-director-types"],
		queryFn: () => master(),
	});

	const toYourself =
		masterData?.find((item) => item.name === "ປະເມີນຕົວເອງ")?.id ?? "";
	const toBoard =
		masterData?.find((item) => item.name === "ຂັ້ນເທິງຖັດ")?.id ?? "";
	const toWorkplace =
		masterData?.find((item) => item.name === "ບ່ອນຢູ່ສັງກັດ")?.id ?? "";
	const toGovernment =
		masterData?.find((item) => item.name === "ເພື່ອນຮ່ວມງານປະເມີນ")?.id ?? "";

	if (isMasterLoading) return null;
	return (
		<div>
			<Breadcrumb>
				<BreadcrumbList>
					<BreadcrumbItem>
						<BreadcrumbPage>ການປະເມີນຄະນະອຳນວຍການ</BreadcrumbPage>
					</BreadcrumbItem>
				</BreadcrumbList>
			</Breadcrumb>
			<Card className="mt-8">
				<CardHeader className="border-b">
					<button
						type="button"
						onClick={() => {
							navigate({
								to: "..",
								replace: true,
							});
						}}
						className="flex gap-1 items-center mb-4"
						aria-label="Go back to tax obligations report"
					>
						<ArrowLeft className="w-5 h-5" />
						ກັບຄືນ
					</button>
					<CardTitle>ການປະເມີນຄະນະອຳນວຍການ</CardTitle>
					<CardDescription>ລາຍການການປະເມີນ </CardDescription>
				</CardHeader>
				<CardContent>
					<Tabs
						value={active || "yourself"}
						defaultValue={active || "yourself"}
						onValueChange={
							// (value) => console.log("Tab Value", value)
							(value) => handleTabChange(value as Tab)
						}
						className="flex flex-col gap-y-12 mt-5"
					>
						<TabsList className="flex flex-wrap gap-2 justify-start items-start bg-transparent">
							<TabsTrigger
								value="yourself"
								className="px-3 bg-gray-100 rounded-full text-black data-[state=active]:bg-green-500 data-[state=active]:text-white"
							>
								ປະເມີນຕົນເອງ
							</TabsTrigger>
							<TabsTrigger
								value="board"
								className="px-3 bg-gray-100 rounded-full text-black data-[state=active]:bg-green-500 data-[state=active]:text-white"
							>
								ຄະນະປະເມີນ
							</TabsTrigger>
							<TabsTrigger
								value="workplace"
								className="px-3 bg-gray-100 rounded-full text-black data-[state=active]:bg-green-500 data-[state=active]:text-white"
							>
								ສັງກັດ
							</TabsTrigger>
							<TabsTrigger
								value="Government"
								className="px-3 bg-gray-100 rounded-full text-black data-[state=active]:bg-green-500 data-[state=active]:text-white"
							>
								ຂັ້ນເທິງຖັດ
							</TabsTrigger>
						</TabsList>

						<TabsContent value="yourself">
							<Yourself formTypeId={toYourself} />
						</TabsContent>
						<TabsContent value="board">
							<Board formTypeId={toBoard} />
						</TabsContent>
						<TabsContent value="workplace">
							<Workplace formTypeId={toWorkplace} />
						</TabsContent>
						<TabsContent value="Government">
							<Government formTypeId={toGovernment} />
						</TabsContent>
					</Tabs>
				</CardContent>
			</Card>
		</div>
	);
}
